/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_EyebrowInputs */

const en_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice`)
};

const es_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Práctica`)
};

const de_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üben`)
};

const zh_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习`)
};

const ar_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التدريب`)
};

const fr_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pratique`)
};

const vi_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luyện tập`)
};

const sw_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fanya mazoezi`)
};

const th_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฝึกฝน`)
};

const bs_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vježba`)
};

const ja_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トレーニング`)
};

const ko_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연습`)
};

const pt_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prática`)
};

const it_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento`)
};

const sv_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Träning`)
};

const nl_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefenen`)
};

const da_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Træning`)
};

const nb_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening`)
};

const fi_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harjoittelu`)
};

const pl_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening`)
};

const ru_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Практика`)
};

const tr_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antrenman`)
};

const hi_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभ्यास`)
};

const id_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latihan`)
};

const ms_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latihan`)
};

const cs_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trénink`)
};

const el_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εξάσκηση`)
};

const he_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תרגול`)
};

const af_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefen`)
};

const hu_practice_eyebrow = /** @type {(inputs: Practice_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyakorlás`)
};

/**
* | output |
* | --- |
* | "Practice" |
*
* @param {Practice_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_eyebrow = /** @type {((inputs?: Practice_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_eyebrow(inputs)
	if (locale === "de") return de_practice_eyebrow(inputs)
	if (locale === "zh") return zh_practice_eyebrow(inputs)
	if (locale === "ar") return ar_practice_eyebrow(inputs)
	if (locale === "fr") return fr_practice_eyebrow(inputs)
	if (locale === "vi") return vi_practice_eyebrow(inputs)
	if (locale === "sw") return sw_practice_eyebrow(inputs)
	if (locale === "th") return th_practice_eyebrow(inputs)
	if (locale === "bs") return bs_practice_eyebrow(inputs)
	if (locale === "ja") return ja_practice_eyebrow(inputs)
	if (locale === "ko") return ko_practice_eyebrow(inputs)
	if (locale === "pt") return pt_practice_eyebrow(inputs)
	if (locale === "it") return it_practice_eyebrow(inputs)
	if (locale === "sv") return sv_practice_eyebrow(inputs)
	if (locale === "nl") return nl_practice_eyebrow(inputs)
	if (locale === "da") return da_practice_eyebrow(inputs)
	if (locale === "nb") return nb_practice_eyebrow(inputs)
	if (locale === "fi") return fi_practice_eyebrow(inputs)
	if (locale === "pl") return pl_practice_eyebrow(inputs)
	if (locale === "ru") return ru_practice_eyebrow(inputs)
	if (locale === "tr") return tr_practice_eyebrow(inputs)
	if (locale === "hi") return hi_practice_eyebrow(inputs)
	if (locale === "id") return id_practice_eyebrow(inputs)
	if (locale === "ms") return ms_practice_eyebrow(inputs)
	if (locale === "cs") return cs_practice_eyebrow(inputs)
	if (locale === "el") return el_practice_eyebrow(inputs)
	if (locale === "he") return he_practice_eyebrow(inputs)
	if (locale === "af") return af_practice_eyebrow(inputs)
	if (locale === "hu") return hu_practice_eyebrow(inputs)
	return en_practice_eyebrow(inputs)
});